import { createAsyncThunk } from '@reduxjs/toolkit';
import { ImageDocumentStoreItem } from '@v2/components/imageHandling/types/types';
import { AppDispatch } from '@store/types';
import { ImageHandlingState } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';
import { getDocumentById } from '@reducers/search';
import { parseAndAddUrlsToImagesDocuments } from './parseAndAddUrlsToImagesDocuments';

export const fetchImageDocumentById = createAsyncThunk<
  { documentId: number; data: ImageDocumentStoreItem[] | null; cached: boolean },
  number,
  { dispatch: AppDispatch }
>('imageHandlingV2/fetchImageDocument', async (documentId, { dispatch, getState }) => {
  const state = getState() as { imageHandlingV2: ImageHandlingState };
  const documentStore = state.imageHandlingV2.imagesDocumentsContexts[String(documentId)];

  // Check if document exists in dictionary and context TTL is still valid
  if (documentStore?.documentIds?.includes(documentId) && documentStore.ttl) {
    const isValid = Date.now() < documentStore.ttl;
    if (isValid) {
      const document = state.imageHandlingV2.imagesDocumentsDict[documentId];
      return { documentId, data: document ? [document] : null, cached: true };
    }
  }

  // Fetch fresh document
  const response = await dispatch(getDocumentById(documentId));

  if (response?.length) {
    // Parse the document with URLs before returning
    const parsedResult = await dispatch(
      parseAndAddUrlsToImagesDocuments({
        imagesDocuments: [response[0]],
      })
    );

    if (parseAndAddUrlsToImagesDocuments.fulfilled.match(parsedResult)) {
      const parsedData = parsedResult.payload?.[0];
      // Message processing will be handled by middleware after store update
      return { documentId, data: parsedData ? [parsedData] : null, cached: false };
    }

    // If parsing fails, return null since we expect ImageDocumentStoreItem[]
    return { documentId, data: null, cached: false };
  }

  return { documentId, data: null, cached: false };
});
